export const TIPO_VENDA_LIST = "TIPO_VENDA_LIST";
export const TIPO_VENDA_GET_BY_ID = "TIPO_VENDA_GET_BY_ID";
export const TIPO_VENDA_CREATE = "TIPO_VENDA_CREATE";
export const TIPO_VENDA_UPDATE = "TIPO_VENDA_UPDATE";
export const TIPO_VENDA_REMOVE = "TIPO_VENDA_REMOVE";
